<div class="modal-body text-center">
  <p class="fw-semi-bold fs-5" i18n="@@patientsList_modalPairingRequest_title">
    Are you following this patient ?
  </p>
  <img
    src="assets/img/img-patient-f.svg"
    class="img-fluid patient-avatar mt-5"
    *ngIf="patient.gender === gender.female; else imgMaleAvatar"
  />
  <ng-template #imgMaleAvatar>
    <img
      src="assets/img/img-patient-m.svg"
      class="img-fluid patient-avatar mt-5"
    />
  </ng-template>
  <h2 class="mt-4">{{ patient.firstName }} {{ patient.lastName }}</h2>
  <p
    class="text-gray-20 mt-5"
    i18n="@@patientsList_modalPairingRequest_description"
  >
    To begin accessing the NMOSD tracker for this patient, confirm that this is
    indeed one of your patients. If not, decline pairing.
  </p>
  <div class="mt-6">
    <button
      type="button"
      (click)="confirmPairing()"
      class="btn btn-primary w-75 text-center m-auto text-uppercase position-relative"
    >
      <img src="assets/icons/icon_pairing.svg" alt="pairing" />
      <span
        class="flex-fill text-center text-uppercase"
        i18n="@@patientsList_modalPairingRequest_confirmButton"
      >
        Confirm Pairing
      </span>
    </button>
    <button
      type="button"
      class="mt-3 btn btn-outline-primary w-75 text-center m-auto text-uppercase"
      (click)="activeModal.dismiss()"
    >
      <span
        class="flex-fill text-center text-uppercase"
        i18n="@@patientsList_modalPairingRequest_declineButton"
      >
        Decline pairing
      </span>
    </button>
  </div>
</div>
